import type { BulkOrderRequest } from '@/types/bulk-order';
import type { BulkOrderRequestFormData } from './types';

/**
 * Transforms bulk order form data into a single bulk order request
 * Backend will create multiple orders (one per product)
 */
export const transformBulkFormToBulkOrderRequest = (
	formData: BulkOrderRequestFormData,
): BulkOrderRequest => {
	const orderRequestDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

	const payload: BulkOrderRequest = {
		// Common fields shared across all orders
		ta_status: String(formData.status), // ✅ Keep as string
		statecode: 1,
		statuscode: 1,
		ta_fedexshippingmethod: formData.shipping?.value ? parseInt(String(formData.shipping.value)) : 0,
		ta_orderrequestdate: orderRequestDate,
		'ta_Clinic@odata.bind': `accounts(${formData.clinic?.value})`,
		ta_clinicpo: formData.clinicPO, // Required field
		'ta_ShippingLocation@odata.bind': `ta_shippinglocationses(${formData.shippingLocation?.value})`, // Required field
		ta_comments: formData.comments || '',

		// Products array - each will become a separate order on backend
		products: formData.products.map((productField) => ({
			'ta_SKU@odata.bind': `ta_products(${productField.productSize})`,
			ta_quantity: String(productField.quantity),
		})),
	};

	// Optional physician field - only add if it exists
	if (formData.physician?.value) {
		// ✅ Remove curly braces from physician ID if present (database returns IDs with {})
		const physicianId = String(formData.physician.value).replace(/[{}]/g, '');
		payload['ta_Doctor@odata.bind'] = `contacts(${physicianId})`;
	}

	return payload;
};

